import React from "react";
import { createRoot } from "react-dom/client";
import "./index.module.css";
import App from "./App.jsx";
import rootReducer from "./root-reducer";

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux"
import { BrowserRouter } from "react-router-dom";
import thunk from "redux-thunk";
import { getResponsiveAssets } from "./image-prefetch";
import prefetchImages from "prefetch-image";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

prefetchImages(getResponsiveAssets());
